import React from "react";
import { Field, ProBadge } from "./editorShared";
import { Input } from "../ui/input";
import { LegalNotesField } from "../LegalNotesField";
import { PAYMENT_TERMS } from "../../lib/calc";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Textarea } from "../ui/textarea";

export default function PaymentSettingsSection({ cur, isPro, proGate, q, set, totals }) {
  return (
    <section className="bg-card border border-slate-200/80 rounded-xl p-6 shadow-sm space-y-5">
      <h2 className="text-base font-semibold text-slate-900">Condizioni di Pagamento</h2>
      <div className="grid sm:grid-cols-3 gap-5">
        <Field label="Sconto sul totale" className="sm:col-span-1">
          <Select value={q.global_discount_type} onValueChange={(v) => set("global_discount_type", v)}>
            <SelectTrigger data-testid="quote-editor-global-discount-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Nessuno</SelectItem>
              <SelectItem value="percent">Percentuale %</SelectItem>
              <SelectItem value="amount">Importo €</SelectItem>
            </SelectContent>
          </Select>
        </Field>
        <Field label={q.global_discount_type === "percent" ? "Valore %" : "Valore €"}>
          <Input
            type="number"
            min="0"
            step="0.01"
            data-testid="quote-editor-global-discount-value"
            value={q.global_discount_value}
            disabled={q.global_discount_type === "none"}
            onFocus={(e) => e.target.select()}
            onChange={(e) => set("global_discount_value", e.target.value)}
            className="font-mono disabled:opacity-50"
          />
        </Field>
      </div>
      <div className="rounded-xl border border-indigo-100 bg-indigo-50/40 p-4 space-y-4">
        <p className="text-sm font-semibold text-slate-900 flex items-center gap-2">Sconto a scadenza (early-bird){!isPro && <ProBadge testid="early-pro-badge" onClick={() => proGate("Lo Sconto a tempo")} />}</p>
        <p className="text-xs text-slate-500 -mt-2">Sconto extra applicato automaticamente se il cliente accetta entro la data indicata.</p>
        <div className="grid sm:grid-cols-3 gap-4">
          <Field label="Tipo">
            <Select value={q.early_discount_type} onValueChange={(v) => (isPro || v === "none" ? set("early_discount_type", v) : proGate("Lo Sconto a tempo"))}>
              <SelectTrigger data-testid="quote-editor-early-discount-type"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Nessuno</SelectItem>
                <SelectItem value="percent">Percentuale %</SelectItem>
                <SelectItem value="amount">{`Importo ${cur}`}</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label={q.early_discount_type === "percent" ? "Valore %" : `Valore ${cur}`}>
            <Input type="number" min="0" step="0.01" data-testid="quote-editor-early-discount-value"
              value={q.early_discount_value} disabled={q.early_discount_type === "none"}
              onFocus={(e) => e.target.select()}
              onChange={(e) => set("early_discount_value", e.target.value)} className="font-mono disabled:opacity-50" />
          </Field>
          <Field label="Entro il">
            <Input type="date" data-testid="quote-editor-early-discount-deadline"
              value={q.early_discount_deadline || ""} disabled={q.early_discount_type === "none"}
              onChange={(e) => set("early_discount_deadline", e.target.value)} className="disabled:opacity-50" />
          </Field>
        </div>
      </div>
      <Field label="Rate di pagamento">
        <Select value={q.payment_terms} onValueChange={(v) => set("payment_terms", v)}>
          <SelectTrigger data-testid="quote-editor-payment-terms-select" className="w-full sm:w-72"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(PAYMENT_TERMS).map(([k, v]) => (
              <SelectItem key={k} value={k}>{v.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>
      <Field label="Termini e Condizioni">
        <Textarea value={q.terms_conditions} onChange={(e) => set("terms_conditions", e.target.value)} rows={4} placeholder="Validità, tempistiche, note…" />
      </Field>
      <LegalNotesField q={q} set={set} totals={totals} />
      <Field label="Clausole Specifiche ex Art. 1341-1342 c.c. (Clausole Vessatorie)">
        <Textarea data-testid="quote-editor-vexatious-clauses" value={q.vexatious_clauses} onChange={(e) => set("vexatious_clauses", e.target.value)} rows={4} placeholder="Clausole da approvare specificamente dal cliente (lascia vuoto per non richiederle)…" />
        <p className="text-xs text-slate-500 mt-1.5 leading-snug">Se compilate, il cliente dovrà approvarle con una seconda spunta dedicata al momento della firma, ai sensi degli artt. 1341 e 1342 del Codice Civile.</p>
      </Field>
    </section>
  );
}
